import { globalHistory } from '@reach/router';

const handleSamePathClick = (link, toggleMobileMenu) => {
  const currentPath = globalHistory.location.pathname;
  const sameLinkPath = currentPath === link;

  sameLinkPath && toggleMobileMenu(false);
};

export default handleSamePathClick;
